export const upgradePlanLink =
  "https://calendly.com/mustard-influencers/upgrade-plan";
